var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('highcharts',{ref:"Chart",staticClass:"chart",staticStyle:{"width":"100%","min-height":"300px","max-height":"500px"},attrs:{"options":_vm.chartOptions}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }